import { Component, Input } from '@angular/core';
import { EarningsEstimate } from '../../api/model/reservation/points-estimate/earnings-estimate.model';
import { Reservation } from '../../api/model/reservation/reservation.model';
import { User } from '../../api/model/user';

@Component({
  selector: 'points-estimation',
  templateUrl: './points-estimation.component.html',
  styleUrls: ['./points-estimation.component.scss']
})
export class PointsEstimationComponent {

  @Input() earningsEstimate: EarningsEstimate;
  @Input() messages;
  @Input() reservation: Reservation;
  @Input() member: User;
  @Input() isAssociated: boolean;
  @Input() simplifiedLoginEnabled: boolean;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/points-estimation/points-estimation.component.ts